import { Temporal } from '@js-temporal/polyfill';
import { CoordinatorService } from './coordinator.service';
import { ScriptItem } from './script-x-item';
import { XItem } from './x-item';

export class CitationParams {
    constructor(
        private coords: CoordinatorService,
        private itm: ScriptItem,
        private inDetail: boolean,
    ) {}

    get resp() {
        let title: any;
        // console.log('####TTTTTT', this.itm._tV);
        if (this.inDetail) {
            title = { tag: '@@@T@@@', value: this.itm.highlight('title') };
        } else {
            title = this.itm.title;
        }
        const resp: { [tag: string]: any } = {
            title,
            authorLs: Array.from(this.itm.get('authorLs') || []),
        };

        const eLs = this.itm.get('editorLs');
        eLs && (resp['editor'] = eLs);

        let tp = this.itm.get('publicationType');
        if (Array.isArray(tp)) tp = tp[0];
        if (!tp) tp === 'article';
        const tmp = this.coords.config$.exportCitationTypeMap;
        const outTp = tmp.get(tp) || tmp.get('article');

        resp['type'] = outTp;
        switch (outTp) {
            case 'patent':
                this._initialCitationPatent(resp);
                break;
            case 'webpage':
                this._initialCitationWebpage(resp);
                break;
            case 'book':
            case 'book-chapter':
                this._initialCitationBook(resp);
                break;
            case 'paper-conference':
                this._initialCitationConferencePaper(resp);
                break;
            default:
                resp['type'] = 'article-journal';
                this._initialCitationJournalArticle(resp);
        }

        // console.log('OUTPUT', this.itm._tV, outTp, resp);
        return resp;
    }

    private _datePart(dt: Temporal.PlainDate) {
        return { 'date-parts': [[dt.year, dt.month, dt.day]] };
    }

    private _initialCitationWebpage(resp: any) {
        const pd = this.itm.get('publicationDate');
        const rd = this.itm.get('retrievedDate');

        pd && (resp.issued = this._datePart(pd));
        rd && (resp.accessed = this._datePart(rd));
    }

    private _initialCitationBook(resp: any) {
        this._startPage(resp);
        this._publisher(resp);
        const v = this.itm.get('volume');
        v && (resp['volume'] = v);
        this._year(resp);

        const isbn = (this.itm.get('isbn') || [])[0];
        isbn && (resp['isbn'] = isbn);
    }

    private _initialCitationJournalArticle(resp: any) {
        this._source(resp);
        this._startPage(resp);

        const an = this.itm.get('articleNumber');
        an && (resp['article-number'] = an);

        ['volume', 'issue'].forEach((k) => {
            const v = this.itm.get(k);
            v && (resp[k] = v);
        });

        this._year(resp);
    }

    private _year(resp: any) {
        const y = this.itm.get('year');
        if (y) {
            resp['issued'] = { 'date-parts': [[y]] };
        }
    }

    private _publisher(resp: any) {
        const v = this.itm.get('publisher');
        v && (resp['publisher'] = v);
    }

    private _initialCitationConferencePaper(resp: any) {
        resp['event'] = this.itm.get('confTitle') || this.itm.get('source');

        this._publicationDate(resp);
        this._source(resp);
        this._startPage(resp);
    }

    private _startPage(resp: any) {
        const sp = this.itm.get('firstPage');
        if (sp) {
            const lp = this.itm.get('lastPage');
            if (lp) resp['page'] = `${sp}-${lp}`;
            else resp['page'] = sp;
            resp['start-page'] = sp;
        }
    }

    private _source(resp: any) {
        const source = this._sourceCitation(this.inDetail);
        if (source) resp['container-title'] = source;
    }

    private _publicationDate(resp: any) {
        const pd = this.itm.get('publicationDate');
        pd?.year && (resp.issued = { 'date-parts': [[pd.year, pd.month, pd.day]] });
    }

    private _initialCitationPatent(resp: any) {
        this._publicationDate(resp);

        const pn = this.itm.get('patentNumber');
        pn && (resp['number'] = pn);
    }

    private _sourceCitation(inDetail: boolean) {
        if (inDetail) return { tag: '@@@S@@@', value: this.itm.highlight('source') };
        return this.itm.get('source');
    }
}
